var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('welcome-menu-card',{attrs:{"current-language":'pt',"hotel":_vm.hotel,"welcome":_vm.welcome},on:{"click:checkin":_vm.goToFindReservation,"click:services":_vm.goToOnlineServices,"click:checkout":_vm.goToOnlineServices}}),_c('expired-pin-modal',{attrs:{"opened":_vm.isExpiredPin},on:{"click:ok":_vm.onConfirm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }